<template>
	<div class='method-payment-container'>

		<label class='form-field-row checkout-card tag-partner' for='method_paypal'>
			<div class="checkout-payment-select" id="t-paypal-input">

				<input
					type="radio"
					id='method_paypal'
					class='hide'
					:checked="stepPaymentStore.method === 'paypal'"
					@click="selectMethod('paypal')"
				>
				<div class="check" for='method_paypal'></div>
				<span>{{ $t("components.payment.paypal") }}<br>
					<span class='payment-free'>{{ $t("components.payment.free") }}</span>
				</span>

				<span class='checkout-payment-icons'>
					<img src="https://api.quomi.it/oldimg/paypal-quomi.webp" alt='logo paypal'>
				</span>
			</div>
		</label>

		<label class='form-field-row checkout-card' for='method_credit-card'>
			<div class="checkout-payment-select" id="t-ccard-input">
				<input
					type="radio"
					id='method_credit-card'
					class='hide'
					:checked="stepPaymentStore.method === 'creditCard'"
					@click="selectMethod('creditCard')"
				>
				<div class="check" for='method_credit-card' />
				<span>{{ $t("components.payment.credit_cart") }}<br>
					<span class='payment-free'>{{ $t("components.payment.free") }}</span>
				</span>

				<span class='checkout-payment-icons'>
					<img src="https://api.quomi.it/oldimg/metodi-pagamento-quomi.webp" alt='$t("components.payment.accepted_cards")'>
				</span>
			</div>
		</label>

		<div v-show="stepPaymentStore.method === 'creditCard'">
      <div id="setup-form">
        <div id="payment-element"></div>
      </div>

			<div v-if="stepPaymentStore.error" class='red-text'>
				{{ stepPaymentStore.error.message }}
			</div>
		</div>

		<br>
	</div>

</template>

<script>
import Checkbox from '../Checkbox'

import { orderStore } from '../../store/orderStore'
import { stepPaymentStore } from '../../store/stepPaymentStore'
import { dates } from '../../mixins/dates'

import { Card } from 'vue-stripe-elements-plus'
import { OrderApi } from '../../api/OrderApi'
import { stripeHelper } from '../../mixins/stripeHelper'    

export default {
  mixins: [
    dates,
    stripeHelper
  ],
	components: {
		Card,
		Checkbox
	},

	data () {
		return {
			orderStore: orderStore.state,
			stepPaymentStore: stepPaymentStore.state,
			showEdenred: false,
      redirectTo: 'checkout'
		}
	},
	props: {
		mode: {
			type: String,
			default: 'standard'
		}
	},
	computed: {
		dateCheckout () {
			return this.$_dates_readableDate(this.orderStore.order.date.checkout)
		},
	    user () {
	      return this.$root.user ? this.$root.user : null
	    }
	},


	methods: {
		onUpdateStripeCard ($event) {
			stepPaymentStore.state.error = $event.error
			stepPaymentStore.state.complete = $event.complete
		},

		selectMethod (method) {
			stepPaymentStore.state.method = method
		},

	},

	mounted () {
    this.initializeStripe();
	}
}

</script>

<style scoped>

h3 {
	font-size: 20px;
	text-transform: uppercase;
	text-align: left;
}

.method-payment-container {
	margin: 0 auto;
	text-align: left;
	max-width: 700px;
}

.checkout-card{
	border-radius: 4px;
	cursor: pointer;
	-webkit-transition: border-color .3s;
	transition: border-color .3s;
	display: flex;
	margin: 20px auto;
}
.checkout-card:hover {
	background-color: #EDEDED;
}
.checkout-payment-icons{
	display:flex;
	align-items: center;
	margin-left: auto;
}
.checkout-payment-icons img{
	max-height: 30px;
	width: auto;
	mix-blend-mode: multiply;
}
.checkout-payment-select{
	width:100%;
	display: flex;
	padding: 5px;
	align-items: center;
	flex-wrap: nowrap;
  font-size: 13px;
}

.checkout-payment-select input[type='radio']{
	height: 16px;
	width: 16px;
	margin-right: 5px;
}

.cc-label {
	padding: 0 0 10px 0;
}

.cc-label > div {
	padding: 0 10px;
}
.payment-free{
	color:var(--quomi-primary);
	font-style: normal;
	font-size: 12px;
}

.checkout-payment-select .radio {
	position: relative;
	display: inline-block;
	height: 50px;
	width: 50px;
	z-index: 2;
}
.checkout-payment-select .check {
	position: relative;
	display: inline-block;
	min-height: 30px;
	min-width: 30px;
	margin-right: 10px;
}

.cc-stripe {
	border: 2px solid #ededed;
	padding: 15px;
	border-radius: 4px;
}
.col-3 .check {
	cursor: pointer;
	height: 37px;
}
.checkout-payment-select .radio::after,
.checkout-payment-select .radio::before,
.checkout-payment-select .check::after,
.checkout-payment-select .check::before {
	/* used to create the check icon and yellow circle/square dot (when element is selected) */
	position: absolute;
	top: 0;
	left: 0;
	content: '';
	height: 100%;
	width: 100%;
	/* Force hardware acceleration */
	-webkit-transform: translateZ(0);
			transform: translateZ(0);
	-webkit-backface-visibility: hidden;
			backface-visibility: hidden;
}
.checkout-payment-select .radio::before {
	/* green circle */
	border: 3px solid #ffffff;
	background: #EDEDED;
	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
.checkout-payment-select .check::before {
	/* green square */
	border: 1.5px solid var(--quomi-primary);
	background: #ffffff;
	-webkit-transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, border-color .3s, -webkit-transform .3s;
	transition: background-color .3s, transform .3s, border-color .3s;
	transition: background-color .3s, transform .3s, border-color .3s, -webkit-transform .3s;
}
.checkout-payment-select .radio::after, .checkout-payment-select .check::after {
	/* check icon */
	background: url('../../assets/img/content/icon-check.svg') no-repeat center center;
}
.checkout-payment-select .radio::before {
	border-radius: 50%;
}
.checkout-payment-select .check::before {
	border-radius: 4px;
}
.checkout-payment-select .selected .radio::before {
	background: var(--quomi-primary);
	border-color: #ffffff;
}
.checkout-payment-select .selected .check::before {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

input[type="radio"]:checked + .check::before {
	background: var(--quomi-primary);
	border-color: var(--quomi-primary);
}

.btn,
.btn:hover {
	margin: 10px 0;
}

.StripeElement {
	background-color: white;
	padding: 10px 12px;
	border-radius: 4px;
	border: 1px solid transparent;
	box-shadow: 0 1px 3px 0 #e6ebf1;
	-webkit-transition: box-shadow 150ms ease;
	transition: box-shadow 150ms ease;
}

.StripeElement--focus {
	box-shadow: 0 1px 3px 0 #cfd7df;
}

.StripeElement--invalid {
	border-color: #fa755a;
}

.StripeElement--webkit-autofill {
	background-color: #fefde5 !important;
}

@media (max-width: 800px) {
	.section-title {
		flex-wrap: wrap;
	}

	.checkout-payment-icons img {
		max-height: 30px;
	}

	.icons {
		margin: 10px 0;
	}

}
</style>
